<div class="container">
  <div class="row">
    <div class="col-lg-6 history">
      <p>File History</p>
      <p *ngIf="images.length == 0">No uploaded files.</p>
      <ng-container *ngIf="images.length > 0">
        <mat-paginator
          [length]="images.length"
          [pageSize]="pageSize"
          (page)="handlePage($event)"
        ></mat-paginator>
        <div
          *ngFor="
            let image of images.slice(
              pageIndex * pageSize,
              (pageIndex + 1) * pageSize
            )
          "
        >
          <mat-card>
            <p>{{ image.date | date : "long" }}</p>
            <img mat-card-image [src]="image.path" />
          </mat-card>
        </div>
      </ng-container>
    </div>
    <div class="col-lg-6 latest">
      <p class="mb-5">Latest</p>
      <p *ngIf="!latestImage">No uploaded files.</p>
      <mat-card *ngIf="latestImage">
        <img mat-card-image [src]="latestImage" />
      </mat-card>
    </div>
  </div>
</div>
